import React, { useState } from "react";
import { Form } from "react-bootstrap";

interface SwitchOption {
  id: string;
  title: string;
  description: string;
  //   icon: React.ReactNode;
}

const options: SwitchOption[] = [
  {
    id: "auto-creation",
    title: "Auto Creation",
    description: "Automatically create contacts for people",
    // icon: <Briefcase size={20} className="text-muted" />,
  },
];

const ContactAutoCreationSwitch = () => {
  const [toggles, setToggles] = useState<Record<string, boolean>>({
    "exclude-nonprofessional": true,
    "exclude-group": true,
  });

  const handleToggle = (id: string) => {
    setToggles((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className="bg-white rounded-3 shadow-sm">
      <Form>
        {options.map((option) => (
          <div key={option.id} className="p-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex gap-3">
                {/* {option.icon} */}
                <div>
                  <div className="fw-medium">{option.title}</div>
                  <div className="text-muted small">{option.description}</div>
                </div>
              </div>
              <Form.Check
                type="switch"
                id={option.id}
                checked={toggles[option.id]}
                onChange={() => handleToggle(option.id)}
                className="fs-7"
              />
            </div>
          </div>
        ))}
      </Form>
    </div>
  );
};

export default ContactAutoCreationSwitch;
